import { FormEvent, useContext, useEffect, useState } from "react"
import { useLocation } from "react-router-dom"
import { toast } from "react-toastify"
import { ModalEstadoContext } from "../../contexts/ModalEstado"
import { moedaMascara } from "../../helpers"
import { assinaturasListaResposta } from "../../interfaces/assinaturas"
import { listarAssinaturas } from "../../services/assinaturas"
import { Button, Loader } from "../Styles"
import Permissoes from "../../middleware/Permissoes"
import DivSituacao from "../DivSituacao"
import FiltrosDefault from "../FiltrosDefault"
import LoadingBarra from "../LoadingBarra"
import ModalAssinaturas from "../ModalAssinaturas"
import NenhumResultadoEncontrado from "../NenhumResultadoEncontrato"
import maisFiltrosImg from '../../assets/img/maisFiltros.png'

function Assinaturas() {

    const location = useLocation()
    const { search } = location
    const params = new URLSearchParams(search)
    const tipo = params.get('tipo')

    const { modal, modalExibir, atualizarInformacoes } = useContext(ModalEstadoContext)

    const [processando, setProcessando] = useState(false)
    const [nenhumResultado, setNenhumResultado] = useState(false)
    const [situacao, setSituacao] = useState("Ativa")
    const [nomeFantasia, setNomeFantasia] = useState("")
    const [maisFiltros, setMaisFiltros] = useState<boolean>(false)

    const [assinaturas, setAssinaturas] = useState<assinaturasListaResposta[]>([])
    const [assinaturasSelecionado, setAssinaturasSelecionado] = useState<assinaturasListaResposta>()

    const [cobrancaAutomatica, setCobrancaAutomatica] = useState("")
    const [recorrencia, setRecorrencia] = useState("")

    const meses = (mes: number) => {

        const meses: { [key: number]: string } = {
            0: 'Janeiro',
            1: 'Fevereiro',
            2: 'Março',
            3: 'Abril',
            4: 'Maio',
            5: 'Junho',
            6: 'Julho',
            7: 'Agosto',
            8: 'Setembro',
            9: 'Outubro',
            10: 'Novembro',
            11: 'Dezembro'
        }

        return meses[mes]
    }

    const filtrar = async (e: FormEvent) => {
        e.preventDefault()
        setAssinaturas([])
        setProcessando(true)
        setNenhumResultado(false)

        try {
            if (!tipo) return
            const queryParams = {
                nomeFantasia,
                tipo,
                situacao,
                cobrancaAutomatica,
                recorrencia
            }

            const resposta = await listarAssinaturas(queryParams)

            if (resposta.status === 200 && resposta.data.length > 0) {
                setAssinaturas(resposta.data)
                setMaisFiltros(false)
                return setProcessando(false)
            }
            setMaisFiltros(false)
            setNenhumResultado(true)
            return setProcessando(false)
        } catch (error) {
            setProcessando(false)
            return toast.error("Erro ao Buscar os Assinaturas")
        }
    }

    const abrirModalCadastrarAssinatura = () => {
        setAssinaturasSelecionado(undefined)
        modalExibir("ModalAssinaturas")
    }

    const abrirModalAtualizarAssinatura = (assinatura: assinaturasListaResposta) => {
        setAssinaturasSelecionado(assinatura);
        modalExibir("ModalAssinaturas")
    }

    useEffect(() => {
        const buscarAssinaturas = async () => {
            setProcessando(true)
            setAssinaturas([])

            try {

                if (!tipo) return

                const queryParams = {
                    nomeFantasia,
                    tipo,
                    situacao,
                    cobrancaAutomatica,
                    recorrencia
                }

                const resposta = await listarAssinaturas(queryParams)

                if (resposta.status === 200 && resposta.data.length > 0) {
                    setAssinaturas(resposta.data)
                    const assinaturaAtualizada = resposta.data.find(
                        (assinatura: assinaturasListaResposta) => assinatura.id === assinaturasSelecionado?.id
                    );
                    setAssinaturasSelecionado(assinaturaAtualizada);
                    setNenhumResultado(false)
                    return setProcessando(false)
                }
                setNenhumResultado(true)
                return setProcessando(false)
            } catch {
                setProcessando(false)
                return toast.error("Erro ao Buscar os Assinaturas")
            }
        }
        buscarAssinaturas()
        
    }, [atualizarInformacoes, tipo])

    return (
        <Permissoes permissoes={['master', 'administrativo', 'financeiro_assinatura', 'financeiro_despesa_recorrente']}>
            <div id='paginaContainer'>
                {modal.nome === "ModalAssinaturas" && <ModalAssinaturas assinatura={assinaturasSelecionado} />}
                {processando && <LoadingBarra />}
                {nenhumResultado && <NenhumResultadoEncontrado />}
                <FiltrosDefault termo={nomeFantasia} situacao={situacao} placeholder={`${tipo === 'receita' ? 'Pesquise pelo nome do cliente' : 'Pesquise pelo nome do colaborador/fornecedor'}`} tipo={tipo === "despesa" ? "Recorrência" : "Assinatura"} onChangeTermo={(e) => setNomeFantasia(e.target.value)} onChangeSituacao={(e) => { setSituacao(e.target.value) }} acaoBtn={abrirModalCadastrarAssinatura} listaSituacao={[{ nome: 'Todas', valor: '' }, { nome: 'Ativas', valor: 'Ativa' }, { nome: 'Pausadas', valor: 'Pausada' }, { nome: 'Canceladas', valor: 'Cancelada' }]} genero='masculino' isLoading={processando} maisFiltros={true} acaoMaisFiltro={() => setMaisFiltros(true)} onSubmit={filtrar} />
                {maisFiltros && <section className='maisOpcoesFiltrosComponente'>
                    <form className='maisOpcoesFiltros' onSubmit={filtrar}>
                        <span className='filtrosContainerTitulo'>
                            <img className='filtrosAvancados' src={maisFiltrosImg} alt='' />
                            <p>Filtros Avançados</p>
                        </span>
                        <section className='opcoesFiltros'>
                            <section>
                                <span>
                                    <label htmlFor="">Frequência</label>
                                    <select value={recorrencia} onChange={(e) => setRecorrencia(e.target.value)} required>
                                        <option selected disabled>Selecione a Frequência</option>
                                        <option value="">Todas</option>
                                        <option value="diaria">Diária</option>
                                        <option value="semanal">Semanal</option>
                                        <option value="mensal">Mensal</option>
                                        <option value="anual">Anual</option>
                                    </select>
                                </span>
                            </section>
                            <section>
                                <span>
                                    <label htmlFor='selectCobrancaAutomatica'>Cobrança Automática</label>
                                    <select
                                        id='selectCobrancaAutomatica'
                                        value={cobrancaAutomatica}
                                        onChange={(e) => setCobrancaAutomatica(e.target.value)}
                                    >
                                        <option value="">Todos</option>
                                        <option value="1">Sim</option>
                                        <option value="0">Não</option>
                                    </select>
                                </span>
                            </section>
                        </section>
                        <span id="botoesContainerFiltrosTarefas">
                            <Button type='reset' cor='cancelar' isLoading={processando} onClick={() => setMaisFiltros(false)}>Cancelar</Button>
                            <Button type='submit' cor='salvar' isLoading={processando} disabled={processando}>
                                {!processando && 'Buscar Dados'}
                                {processando && <Loader isLoading={processando} />}
                            </Button>
                        </span>
                    </form>
                </section>}
                <section id='fundoContainerPagina'>
                    <table id='tabelaListaContainer'>
                        <thead>
                            <tr>
                                <th id='ladoEsquerdoContent' align='left'>Nome Fantasia</th>
                                <th align='left'>Descrição</th>
                                <Permissoes permissoes={['master', 'administrativo']}>
                                    <th align='left'>Valor Total</th>
                                </Permissoes>
                                <th align='left'>Recorrência</th>
                                <th align='left'>Mês da Cobrança</th>
                                <th align='left'>Dia da Cobrança</th>
                                <th align='center'>Situação</th>
                            </tr>
                        </thead>
                        <tbody>
                            {assinaturas.map((assinatura, index) => (
                                <>
                                    <tr key={index} onClick={() => abrirModalAtualizarAssinatura(assinatura)}>
                                        <td className='primeiraColuna descricaoCobranca'>{assinatura.cadastro.nomeFantasia}</td>
                                        <td>{assinatura.descricao}</td>
                                        <Permissoes permissoes={['master', 'administrativo']}>
                                            <td>{Number(assinatura.valorTotal).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</td>
                                        </Permissoes>
                                        <td align="left">{assinatura.recorrencia.charAt(0).toUpperCase() + assinatura.recorrencia.substring(1)}</td>
                                        <td align="left">{assinatura.recorrenciaMes ? meses(assinatura.recorrenciaMes) : 'Todos os Meses'}</td>
                                        <td align="left">{assinatura.recorrenciaDia?.toString().padStart(2, '0')}</td>
                                        <td className='ladoDireitoContent' align='center'>
                                            <DivSituacao texto={`${assinatura.situacao.charAt(0).toUpperCase()}${assinatura.situacao.substring(1)}`} cor={assinatura.situacao.toLowerCase().replace(/\s+/g, '')} />
                                        </td>
                                    </tr>
                                </>
                            ))}
                        </tbody>
                    </table>
                    {!processando && assinaturas.length > 0 && 
                        <Permissoes permissoes={["master"]}>
                            <div className="totalizacaoDados">
                                <span>
                                    <p>Quantidade</p>
                                    <h1>{assinaturas.length.toString().padStart(2, '0')}</h1>
                                </span>
                                <span>
                                    <p>Total Anual</p>
                                    <h1>{moedaMascara(assinaturas.filter(assinatura => (assinatura.recorrencia === 'anual')).reduce((acc: number, item: { valorTotal: number }) => acc + (Number(item.valorTotal)), 0) * 100)}</h1>
                                </span>
                                <span>
                                    <p>Provisão Mensal</p>
                                    <h1>{moedaMascara((assinaturas.filter(assinatura => (assinatura.recorrencia === 'anual')).reduce((acc: number, item: { valorTotal: number }) => acc + (Number(item.valorTotal)), 0) / 12).toFixed(2))}</h1>
                                </span>
                                <span>
                                    <p>Total Mensal</p>
                                    <h1>{moedaMascara(assinaturas.filter(assinatura => (assinatura.recorrencia === 'mensal')).reduce((acc: number, item: { valorTotal: number }) => acc + (Number(item.valorTotal)), 0).toFixed(2))}</h1>
                                </span>
                                <span>
                                    <p>Total Mensal + Provisão</p>
                                    <h1>{moedaMascara((assinaturas.filter(assinatura => (assinatura.recorrencia === 'mensal')).reduce((acc: number, item: { valorTotal: number }) => acc + (Number(item.valorTotal)), 0) + (assinaturas.filter(assinatura => (assinatura.recorrencia === 'anual')).reduce((acc: number, item: { valorTotal: number }) => acc + (Number(item.valorTotal)), 0) / 12)).toFixed(2))}</h1>
                                </span>
                            </div>
                        </Permissoes>
                    }
                </section>
            </div>
        </Permissoes>
    )
}

export default Assinaturas
